// extracted by mini-css-extract-plugin
export default {"searchContainer":"styles_searchContainer__4RKJK","transparent":"styles_transparent__0il2W"};